var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 205,
    height: 205,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-1.1111111111111112s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-1.1111111111111112s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.98133329356934,69.28362829059617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.8888888888888888
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9722222222222222s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9722222222222222s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.20944533000791,79.54423259036625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.7777777777777778
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8333333333333333s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8333333333333333s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.00000000000001,75.98076211353316)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(119.99999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.6666666666666666
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6944444444444444s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6944444444444444s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.80922137642275,60.260604299770065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.5555555555555556
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5555555555555556s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5555555555555556s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.809221376422748,39.73939570022994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.4444444444444444
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.41666666666666663s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.41666666666666663s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.999999999999986,24.019237886466847)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(239.99999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.3333333333333333
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2777777777777778s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2777777777777778s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.209445330007895,20.455767409633758)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.2222222222222222
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1388888888888889s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1388888888888889s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.98133329356934,30.716371709403813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#9abd71",
    fillOpacity: 0.1111111111111111
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "2.38 2.38;1 1",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.25s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  })))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loading-circle.53829003c3a65a5028551bc1caa32934.svg";
export { ForwardRef as ReactComponent };